import {Pos} from '../../models/common/pos'

export const origo: Pos = {x: 0, y: 0}
